import { ElementType, Suspense } from 'react';
import Loader from './Loader';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const Loadable = (Component: ElementType) => (props: any) => {
	return (
		<Suspense fallback={<Loader />}>
			<Component {...props} />
		</Suspense>
	);
};

export default Loadable;
